import PSA from '../../psa';
import Validator from '../../utils/Validator';

const RGX_OTH = /[. /:*;\\+\-?!"§$%&()=\[\]{}~#|<>^']/;
const RGX_WRD = /[^. /:*;\\+\-?!"§$%&()=\[\]{}~#|<>^']/;

export default class RchDteExt {

	constructor(rtw) {
		this.rchTxt = rtw;
	}

	destroy() {
		this.rchTxt = null;
	}

	wdgAct(args) {
		let hdl = false;
		if ( this.rchTxt ) {
			const wdg = this.rchTxt.getRapWdg();
			if ( wdg ) {
				const ctt = wdg.getText();
				const data = args.data || {};
				const act = data.act || '';
				if ( Validator.isString(act) ) {
					switch ( act ) {
						case 'mvc':
							const ofs = data.ofs || 0;
							let pos = data.pos;
							if ( typeof pos !== 'number' ) {
								pos = -1;
							}
							try {
								if ( pos !== -1 ) {
									pos = Math.max(0, Math.min(ctt.length, pos + ofs));
									const sel = [ pos, pos ];
									wdg.setSelection(sel);
								}
								this._hdlCsrMov(data.dir === 'rgt', false);
							} catch ( err ) {
								console.error(err);
							}
							hdl = true;
							break;
						default:
							break;
					}
				}
			}
		}
		return hdl;
	}

	hdlKeyPress(evt, sns) {
		const key = evt.getKeyIdentifier();
		const sft = evt.isShiftPressed();
		const ctr = evt.isCtrlPressed();
		const alt = evt.isAltPressed();
		let hdl = false;
		let frc_sns = false;
		switch ( key ) {
			case 'Left':
			case 'Right':
			case 'Home':
			case 'End':
				hdl = !sft && !ctr && !alt;
				if ( hdl ) {
					const rgt = (key === 'Right') || (key === 'End');
					const ful = (key === 'Home') || (key === 'End');
					this._hdlCsrMov(rgt, ful);
					evt.stopPropagation();
					evt.preventDefault();
				}
				break;
			case 'Down':
			case 'Up':
				hdl = false;
				frc_sns = true;
				break;
			default:
				break;
		}
		if ( !hdl ) {
			this.rchTxt.hdlKeyPress(evt, sns || frc_sns);
		}
	}

	_hdlCsrMov(rgt, ful) {
		if ( this.rchTxt ) {
			const wdg = this.rchTxt.getRapWdg();
			if ( wdg ) {
				const ctt = wdg.getText();
				const len = ctt.length;
				if ( ful ) {
					const sel = rgt ? [ len, len ] : [ 0, 0 ];
					wdg.setSelection(sel);
				} else {
					let mvs = false;
					const sel = wdg.getSelection();
					const nsl = [ 0, 0 ];
					if ( rgt ) {
						if ( sel[1] >= len ) {
							nsl[0] = nsl[1] = len;
						} else {
							mvs = true;
						}
					} else {
						if ( sel[0] < 1 ) {
							nsl[0] = nsl[1] = 0;
						} else {
							mvs = true;
						}
					}
					if ( mvs ) {
						let beg = rgt ? sel[1] : sel[0] - 1;
						let end = beg;
						if ( rgt ) {
							while ( (beg < len) && RGX_OTH.test(ctt.charAt(beg)) ) {
								++beg;
							}
							end = beg;
							while ( (end <= len) && RGX_WRD.test(ctt.charAt(end)) ) {
								++end;
							}
						} else {
							while ( (end > 0) && RGX_OTH.test(ctt.charAt(end)) ) {
								--end;
							}
							end = Math.min(end + 1, len);
							beg = end - 1;
							while ( (beg >= 0) && RGX_WRD.test(ctt.charAt(beg)) ) {
								--beg;
							}
							beg = Math.min(beg + 1, end);
						}
						beg = Math.max(0, Math.min(beg, len));
						end = Math.max(0, Math.min(end, len));
						nsl[0] = beg;
						nsl[1] = end;
					}
					if ( (sel[0] !== nsl[0]) || (sel[1] !== nsl[1]) ) {
						wdg.setSelection(nsl);
						this.rchTxt.sndUpdSel();
					}
				}
			}
		}
	}
}
